'use strict'
// Template version: 1.3.1
// see http://vuejs-templates.github.io/webpack for documentation.

const path = require('path')

const defaultEnv = (() => {
  switch (process.env.SUB_ENV) {
    case 'local':
      return require('./local.env')
    case 'test':
      return require('./test.env')
    case 'master':
    case 'hotfix':
      return require('./prod.env')
    default:
      return require('./dev.env')
  }
})()

const env = {
  NODE_ENV: process.env.NODE_ENV || defaultEnv.NODE_ENV,
  SUB_ENV: process.env.SUB_ENV || defaultEnv.SUB_ENV,
  VUE_APP_DOC_TITLE_PREFIX: process.env.VUE_APP_DOC_TITLE_PREFIX || defaultEnv.VUE_APP_DOC_TITLE_PREFIX || '',
  VUE_APP_MW_DOC: process.env.VUE_APP_MW_DOC || defaultEnv.VUE_APP_MW_DOC || null,
  VUE_APP_DEV_BACKEND_HOST: process.env.VUE_APP_DEV_BACKEND_HOST || defaultEnv.VUE_APP_DEV_BACKEND_HOST,

  /**Анимация потоков, если используются настройки слоев по умолчанию (если настройки слоев ни разу не сохранялись в БД)*/
  VUE_APP_FLOW_ANIMATION: process.env.VUE_APP_FLOW_ANIMATION || defaultEnv.VUE_APP_FLOW_ANIMATION || false,

  /**Предметы на потоках, если используются настройки слоев по умолчанию (если настройки слоев ни разу не сохранялись в БД)*/
  VUE_APP_FLOW_SHOW_ITEMS: process.env.VUE_APP_FLOW_SHOW_ITEMS || defaultEnv.VUE_APP_FLOW_SHOW_ITEMS || false,
  
  VUE_APP_SHOW_B3_GIS: process.env.VUE_APP_SHOW_B3_GIS || defaultEnv.VUE_APP_SHOW_B3_GIS || false,
}

module.exports = {
  env,

  dev: {
    // Paths
    assetsSubDirectory: 'static_assets',
    assetsPublicPath: '/',
    proxyTable: {
      // proxy all requests starting with /api to jsonplaceholder
      // '/api': {
      //   target: 'http://localhost:8000/',
      //   changeOrigin: true,
      //   pathRewrite: {
      //     '^/api': 'api'
      //   },
      //   logLevel: 'debug'
      // }
    },
    // Various Dev Server settings
    host: 'localhost', // can be overwritten by process.env.HOST
    port: 8080, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
    autoOpenBrowser: false,
    errorOverlay: true,
    notifyOnErrors: true,
    poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-

    // Use Eslint Loader?
    // If true, your code will be linted during bundling and
    // linting errors and warnings will be shown in the console.
    useEslint: false,
    // If true, eslint errors and warnings will also be shown in the error overlay
    // in the browser.
    showEslintErrorsInOverlay: false,

    /**
     * Source Maps
     */

    // https://webpack.js.org/configuration/devtool/#development
    devtool: 'cheap-module-eval-source-map',

    // If you have problems debugging vue-files in devtools,
    // set this to false - it *may* help
    // https://vue-loader.vuejs.org/en/options.html#cachebusting
    cacheBusting: true,

    cssSourceMap: true
  },

  docker: {
    proxyTable: {
      // proxy all requests starting with /api to jsonplaceholder
      '/api': {
        target: 'http://127.0.0.1:8000/',
        changeOrigin: true,
        pathRewrite: {
          '^/api': 'api'
        },
        logLevel: 'debug'
      }
    }
  },

  build: {
    // Template for index.html
    index: path.resolve(__dirname, '../dist/index.html'),

    // Paths
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static_assets',
    assetsPublicPath: '/',

    /**
     * Source Maps
     */

    productionSourceMap: true,
    // https://webpack.js.org/configuration/devtool/#production
    devtool: '#source-map',

    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],

    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report
  }
}



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = FhoZ
// module chunks = 40